import { useGoogleLogin } from '@react-oauth/google';
import { useCallback } from 'react';
import Button from '../../../components/Button';
import IconGoogle from '../../../components/icons/IconGoogle';
import { useAxios } from '../../../utils/hooks';

interface Props {
    onConnect: () => void;
}

export default function ConnectGoogle({ onConnect }: Props) {
    const axios = useAxios();
    const connectGoogleAccount = useCallback(
        (code: string) => axios.current?.post<{ ok: boolean }>('/google/connect', { code }),
        [axios]
    );
    const login = useGoogleLogin({
        scope: 'https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive',
        onSuccess: (codeResponse) => {
            connectGoogleAccount(codeResponse.code)?.then((res) => {
                if (res.data.ok) {
                    onConnect();
                }
            });
        },
        flow: 'auth-code',
    });

    return (
        <Button onClick={() => login()}>
            <IconGoogle className="w-5 inline" /> Connect Google Account
        </Button>
    );
}
